/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SecureIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SecureIcon({
  children,
  viewPath = "/DesignSystem/Svgs/SecureIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="SecureIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-ZQT1JD': alignSelf,'--mt-2-ZQT1JD': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZQT1JD': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZQT1JD': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZQT1JD': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZQT1JD': opacity,'--w-10-ZQT1JD': typeof width === 'number' ? `${width}px` : width,'--h-11-ZQT1JD': typeof height === 'number' ? `${height}px` : height,'--a-7-ZQT1JD': isAnimated ? animation : "none",'--sd-8-ZQT1JD': isAnimated ? strokeDashoffset : 0,'--sd-9-ZQT1JD': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="SecureIcon.SvgPath"
  data-view-path={viewPath}
 d="M16 2.6s-5.9.3-11.8 3.7C4.2 26.1 16 29 16 29s11.8-2.9 11.8-22.7C21.9 2.9 16 2.6 16 2.6z"
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 style={{'--f-12-ZQT1JD': fill,'--s-13-ZQT1JD': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="SecureIcon.SvgPath:1"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 d="M22.3 9.7l-7.1 7.1-4.3-4.3"
 style={{'--f-12-ZQT1JD': fill,'--s-13-ZQT1JD': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}